import React from 'react';

import { type ContentCardData, ContentCardGroup, type GroupData } from '@af/design-system-docs-ui';

import OverviewPage from '../../templates/overview-page';
import heroDark from './_assets/hero.dark.png';
import heroLight from './_assets/hero.light.png';

const data: GroupData<ContentCardData>[] = [
	{
		title: 'Access up-to-date guidelines and tools ',
		cards: [
			{
				title: 'Design',
				description: 'Explore design guidelines, and access Figma libraries and plugins.',
				href: '/get-started/design',
				icon: 'design',
			},
			{
				title: 'Develop',
				description: 'Set up your environments, and learn how to use components and compose code.',
				href: '/get-started/develop',
				icon: 'develop',
			},
			{
				title: 'Content design',
				description:
					'Learn about UI content standards, voice and tone principles, and design assets.',
				href: '/get-started/content-design',
				icon: 'content-design',
			},
			{
				title: 'Figma libraries',
				description:
					'Access design system Figma libraries, plugins, and accessibility annotations.',
				href: '/get-started/design/figma-libraries',
				icon: 'figma',
			},
		],
	},
	{
		title: 'Explore the design system and contact us',
		cards: [
			{
				title: 'About the design system',
				description:
					'Learn about the design system, the benefits of using it, and our values and principles.',
				href: '/get-started/about-atlassian-design-system',
				icon: 'vision',
			},
			{
				title: 'Contact us',
				description:
					'How to get help from the Atlassian Design System team and contribute to the system.',
				href: '/contact-us',
				icon: 'contactUs',
			},
		],
	},
];

export default (): React.JSX.Element => {
	return (
		<OverviewPage
			categorySlug="get-started"
			title="Get started"
			description="Start designing and developing beautiful interfaces with Atlassian Design System foundations, components, and standards."
			image={{
				light: heroLight,
				dark: heroDark,
			}}
			entries={data}
			defaultIcon="bullet-list"
		>
			<ContentCardGroup data={data} />
		</OverviewPage>
	);
};
